import { render, staticRenderFns } from "./AccessSystemView.vue?vue&type=template&id=5dd521a6&"
import script from "./AccessSystemView.vue?vue&type=script&lang=js&"
export * from "./AccessSystemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports